import { Outlet } from 'react-router-dom';

import { AdminNav } from './AdminNav';

/**
 * The frame every admin page sits in.
 *
 * ## Why it is a layout route rather than a component each page renders
 *
 * All six pages used to render `<AdminNav />` themselves inside their own
 * `mx-auto max-w-4xl` or `max-w-5xl` wrapper - six copies of the chrome, and
 * two different measures depending on which page you were on. Moving it here
 * makes the width one decision instead of six, and means a new admin page gets
 * the navigation by existing rather than by remembering.
 *
 * ## Full width, unlike the rest of the site
 *
 * The public pages are measured for reading - a column of prose and a column of
 * tracks. This is a workbench: tables of users, queues of reports, a dashboard
 * of charts. Constraining it to the same measure wasted half a monitor and made
 * every table scroll horizontally for no reason.
 *
 * A ceiling rather than truly edge-to-edge, because a data table three metres
 * wide is its own kind of unreadable.
 */
export function AdminLayout() {
  return (
    <div className="mx-auto flex w-full max-w-[1800px] flex-col gap-5 px-6 py-8">
      <AdminNav />
      <Outlet />
    </div>
  );
}
